import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
import { getter, setter, STR_ERRORS, connectionStore, ClassDecoratorFactory } from "../../common";
import { ConnectionNames } from "../../contracts";
const connectionName = ConnectionNames.sports;
export function sportsbookConnectionHOF(OriginalClass, options, onlyConnect = false) {
    const callback = (instance) => {
        const conn = connectionStore.get(connectionName);
        if (typeof conn === "undefined") {
            throw new Error(STR_ERRORS.NoConnectionsAvailable);
        }
        if (instance.query) {
            instance.query = instance.query;
            instance.onData = instance.onData.bind(instance);
        }
        if (instance.onError) {
            instance.onError = instance.onError.bind(instance);
        }
    };
    const proxyHandler = {
        get: getter,
        set: setter.bind(undefined, connectionName, SDQuerySubscribersStore, onlyConnect),
    };
    const factory = ClassDecoratorFactory(callback, proxyHandler);
    const DecoratedClass = factory(options)(OriginalClass);
    return class extends DecoratedClass {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...params) {
            super(...params);
        }
    };
}
//# sourceMappingURL=sportsbookConnectionHOF.js.map